import React from 'react';

const API_URL = 'https://alb.deardiary.io';

interface UserInfo {
    name?: string;
    nickname?: string;
    email?: string;
    sub?: string;
}

export default function Dashboard({ user }: { user: UserInfo }) {

    const displayName = user.name || user.nickname || user.email || user.sub;

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        window.location.href = `${API_URL}/auth/logout`;
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
          <h1>Dashboard Page</h1>
          <h2>Welcome, {displayName}</h2>
          <br></br>
          <button
              style={{ backgroundColor: '#D8BFD8', color: 'black', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontSize: '16px' }}
              onClick={handleLogout}
          >
              Logout
          </button>
      </div>
  );
}
